import { OTHERS_COLOR, SELECTED_BRAND_COLOR } from '../../../utils/utils';
import { getFirstSeriesPalette } from '../../../utils/chartTheme';
import React, { useRef } from 'react';
import { PieChartData } from '../../../models/common/PieChartData';
import PieChart from '../pie-chart/PieChart';
import { t } from 'i18next';
import './PieChartWithLegend.scss';

interface PieChartWithLegendProps {
  chartData: PieChartData[];
  selectedBrand?: string;
  size?: 'SM' | 'MD' | 'LG' | 'XXL';
  colorPalette?: string[];
  showHalf?: boolean;
  showValues?: boolean;
  showLegend?: boolean;
}

const PieChartWithLegend: React.FC<PieChartWithLegendProps> = ({
  chartData,
  selectedBrand,
  size = 'SM',
  colorPalette = getFirstSeriesPalette(),
  showHalf = false,
  showValues = false,
  showLegend = true,
}) => {
  const chartRef = useRef<any>(null);
  const legendRef = useRef<HTMLDivElement>(null);

  const handleMouseEnter = (name: string) => {
    const chart = chartRef.current?.getEchartsInstance();
    if (!chart) return;
    chart?.dispatchAction({ type: 'highlight', seriesIndex: 0, name });
    chart?.dispatchAction({ type: 'showTip', seriesIndex: 0, name });
  };

  const handleMouseLeave = (name: string) => {
    const chart = chartRef.current?.getEchartsInstance();
    if (!chart) return;
    chart?.dispatchAction({ type: 'downplay', seriesIndex: 0, name });
    chart?.dispatchAction({ type: 'hideTip' });
  };

  return (
    <div className="pie-chart-with-legend">
      <PieChart
        chartData={chartData}
        selectedBrand={selectedBrand}
        size={size}
        chartRef={chartRef}
        legendRef={legendRef}
        colorPalette={colorPalette}
        showHalf={showHalf}
      />
      {showLegend && (
        <div className="stats-box__legend" ref={legendRef}>
          {chartData.map((data, index) => {
            const color =
              data.name === selectedBrand
                ? SELECTED_BRAND_COLOR
                : data.name === t('others')
                ? OTHERS_COLOR
                : colorPalette[index];

            return (
              <div
                className="legend-tag"
                key={data.name}
                data-name={data.name}
                onMouseEnter={() => handleMouseEnter(data.name)}
                onMouseLeave={() => handleMouseLeave(data.name)}
              >
                <span style={{ backgroundColor: color }} />
                {data.name}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PieChartWithLegend;
